import { defineRecipe } from '@chakra-ui/react';

export const inputRecipe = defineRecipe({
  base: {
    borderColor: 'grey.light.2',
    borderWidth: '1px',
    borderStyle: 'solid',
    backgroundColor: 'bg',
    color: 'grey.dark.1',
    padding: '0 1rem',
    rounded: 'smaller',
    fontSize: '0.875rem', // 14px
    minWidth: '48px',

    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '0.5rem',

    outline: 'none',

    fontFamily: 'acBase',

    transitionDuration: 'faster',
    transitionTimingFunction: 'linear',
    transitionProperty: 'border-color',

    _placeholder: {
      color: 'grey.light.3',
    },

    _active: {
      borderColor: 'grey.light.3',
    },

    _focus: {
      borderColor: 'grey.light.3',
    },

    _open: {
      borderColor: 'grey.light.3',
    },

    '&[type=time]': {
      position: 'relative',
      fontFamily: 'inherit',
      padding: '0 0 0 1rem',
    },

    '& svg': {
      width: '1rem',
      height: '1rem',
    },

    _disabled: {
      cursor: 'disabled',
      backgroundColor: 'grey.light.0',
    },
  },
  variants: {
    sizing: {
      'fill-width': {
        width: '100%',
        flexGrow: 1,
      },
    },
    size: {
      compact: {
        height: '30px',
        padding: '0 0.5rem',
        borderRadius: 'small',
      },
      med: {
        height: '40px',
      },
      taller: {
        height: '44px',
        padding: '8px 12px',
      },
    },
    error: {
      none: {
        borderColor: 'grey.light.2',
        _active: {
          borderColor: 'grey.light.3',
        },

        _focus: {
          borderColor: 'grey.light.3',
        },

        _open: {
          borderColor: 'grey.light.3',
        },
      },
      missing: {
        borderColor: 'halton.red',

        _active: {
          borderColor: 'halton.red',
        },

        _focus: {
          borderColor: 'halton.red',
        },

        _open: {
          borderColor: 'halton.red',
        },
      },
    },
    looksDisabled: {
      true: {
        backgroundColor: 'grey.light.0',
        borderColor: 'grey.light.2 !important',
      },
    },
  },
  defaultVariants: {
    size: 'med',
    error: 'none',
  },
});
